const Settings = {
  putSettings: () => `/Agency/PutPrintingSettings`,
  getSettings: () => `/Agency/GetPrintingSettings`,
};

export default Settings;
